// Secondary-market rules quoted in copy. Every money figure (fees, VAT,
// bands, caps, minimums) is priced by the server — quotes, property detail
// and the sell overview — so none of it is hardcoded here.

/** Days a listing stays live once approved (and per renewal). */
export const LISTING_VALIDITY_DAYS = 30
/** Lock-in after a purchase before tokens can be listed. */
export const LOCK_IN_MONTHS = 3
